import React from "react";
import { Box, LinearProgress, LinearProgressProps, Typography } from "@mui/material";

interface ILinearProgressIndicatorProps {
  value: number;
  color?: LinearProgressProps["color"];
  height?: string;
  progressText?: boolean;
}

export const LinearProgressIndicator: React.FC<ILinearProgressIndicatorProps> = ({
  value,
  color,
  height,
  progressText,
}) => {
  return (
    // We need to adjust the width due to its rounding corners
    <Box width={"calc(100% - 24px)"} mx="auto">
      {progressText && (
        <Typography variant="subtitle1" mb={0.5}>
          {`${value}%`}
        </Typography>
      )}
      <LinearProgress
        variant="determinate"
        value={value}
        color={color}
        sx={{ height: height ? height : undefined, borderRadius: "8px" }}
      />
    </Box>
  );
};
